import { render } from "./Prompt.vue?vue&type=template&id=502d9ca1"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import "./Prompt.vue?vue&type=style&index=0&id=502d9ca1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__